import SayWhatYouDo from './SayWhatYouDo';

function App() {
  return <SayWhatYouDo />;
}

export default App;
